// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbot-popover .ant-popover-inner-content {
  max-width: 500px;
  min-width: 500px;
  min-height: 450px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/AIChatBot/ChatbotUI.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;AAC3B","sourcesContent":[".chatbot-popover .ant-popover-inner-content {\n  max-width: 500px;\n  min-width: 500px;\n  min-height: 450px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
